import { render, staticRenderFns } from "./ReferralButton.vue?vue&type=template&id=2bc8aad0"
import script from "./ReferralButton.vue?vue&type=script&lang=js"
export * from "./ReferralButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports